/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import find from "lodash/find";

// import { Rect } from "ltcase/structure/Rect";
export class Direction {
  public static FRONT = new Direction(0);
  public static BACK = new Direction(1);
  public static LEFT = new Direction(2);
  public static RIGHT = new Direction(3);
  public static TOP = new Direction(4);
  public static BOTTOM = new Direction(5);

  public static X = 0;
  public static Y = 1;
  public static Z = 2;

  public static dirs = [
    Direction.FRONT,
    Direction.BACK,
    Direction.LEFT,
    Direction.RIGHT,
    Direction.TOP,
    Direction.BOTTOM,
  ];

  public static fromName(name: string): Direction | null {
    // also matches direction names like "left_and_right" or "front_and_back" with a matching side
    const result = find(Direction.dirs, (dir) => name.indexOf(dir.name) === 0);
    return result || null;
  }

  public isFront = false;
  public isRight = false;
  public isBack = false;
  public isLeft = false;
  public isBottom = false;
  public isTop = false;
  public isLR = false;
  public isFB = false;
  public isTB = false;
  public displayName = "";
  public name = "";
  public code: unknown;
  public dimX2d = "";
  public dimY2d = "";

  public axis = 0;
  public trans: number[] = [];
  public side = 0;
  public adjacent = 0;

  constructor(code: number, side?: number) {
    const dirs = [
      // dimensions are width x depth x height (indices: 0, 1, 2)
      // axis: dimension of the normal vector of this side
      // side: "sign" of the axis vector;
      //     0: we are looking on the inside of the referenced side
      //     1: we are looking on the outside of the referenced side;

      {
        adjacent: 0,
        axis: 1,
        code: 1,
        dimX2d: "width",
        dimY2d: "height",
        displayName: "hinten",
        isBack: 1,
        isBottom: 0,
        isFB: 1,
        isFront: 0,
        isLR: 0,
        isLeft: 0,
        isRight: 0,
        isTB: 0,
        isTop: 0,
        name: "back",
        side: 0,
        trans: [0, 2],
      },
      {
        adjacent: 1,
        axis: 0,
        code: 2,
        dimX2d: "depth",
        dimY2d: "height",
        displayName: "links",
        isBack: 0,
        isBottom: 0,
        isFB: 0,
        isFront: 0,
        isLR: 1,
        isLeft: 1,
        isRight: 0,
        isTB: 0,
        isTop: 0,
        name: "left",
        side: 0,
        trans: [1, 2],
      },
      {
        adjacent: 0,
        axis: 1,
        code: 0,
        dimX2d: "width",
        dimY2d: "height",
        displayName: "vorne",
        isBack: 0,
        isBottom: 0,
        isFB: 1,
        isFront: 1,
        isLR: 0,
        isLeft: 0,
        isRight: 0,
        isTB: 0,
        isTop: 0,
        name: "front",
        side: 1,
        trans: [0, 2],
      },
      {
        adjacent: 1,
        axis: 0,
        code: 3,
        dimX2d: "depth",
        dimY2d: "height",
        displayName: "rechts",
        isBack: 0,
        isBottom: 0,
        isFB: 0,
        isFront: 0,
        isLR: 1,
        isLeft: 0,
        isRight: 1,
        isTB: 0,
        isTop: 0,
        name: "right",
        side: 1,
        trans: [1, 2],
      },
      {
        adjacent: 1,
        axis: 2,
        code: 4,
        dimX2d: "width",
        dimY2d: "depth",
        displayName: "oben",
        isBack: 0,
        isBottom: 0,
        isFB: 0,
        isFront: 0,
        isLR: 0,
        isLeft: 0,
        isRight: 0,
        isTB: 1,
        isTop: 1,
        name: "top",
        side: 1,
        trans: [0, 1],
      },
      {
        adjacent: 1,
        axis: 2,
        code: 5,
        dimX2d: "width",
        dimY2d: "height",
        displayName: "unten",
        isBack: 0,
        isBottom: 1,
        isFB: 0,
        isFront: 0,
        isLR: 0,
        isLeft: 0,
        isRight: 0,
        isTB: 1,
        isTop: 0,
        name: "bottom",
        side: 0,
        trans: [0, 1],
      },
    ];

    const dir: unknown =
      side === undefined
        ? find(dirs, { code })
        : find(dirs, (d) => d.axis === code && d.side === side); // if side is set, code means axis

    // copy properties of dir to this:
    Object.assign(this, dir);
  }

  public eq({ axis, side }: { axis: number; side: number }): boolean {
    return axis === this.axis && side === this.side;
  }

  public nextCCW(): Direction | null {
    if (this.isFront) {
      return Direction.RIGHT;
    }
    if (this.isRight) {
      return Direction.BACK;
    }
    if (this.isBack) {
      return Direction.LEFT;
    }
    if (this.isLeft) {
      return Direction.FRONT;
    }
    return null;
  }

  // public static fromRect(rect: { axis, side }): Direction | null {
  //   let result = (find(Direction.__dirs, { axis: rect.axis, side: rect.side }) as Direction | undefined);
  //   return result || null;
  // }
}
